<template>
  <div class="admin-project-wrapper">
    <div class="admin-project">
      <div class="current-project-background" v-if="currentProject" :style="{ backgroundImage: `url(${currentProject.mainImageUrl})`}">
        <div class="current-project">
          {{ currentProject.name }}
          <span>{{ currentProject.location }}</span>
        </div>
      </div>
      <div class="navigation-bar">
        <router-link :to="`/admin/projects/${currentProject.id}/investments`">Socios</router-link>
        <router-link :to="`/admin/projects/${currentProject.id}/payments`">Pagos</router-link>
      </div>
      <router-view class="view"></router-view>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapActions } = createNamespacedHelpers('admin');

export default {
  data() {
    return {
      currentProject: {},
    };
  },
  methods: {
    ...mapActions([
      'getProjects',
    ]),
  },
  computed: {
    ...mapState([
      'projects',
      'users',
    ]),
  },
  mounted() {
    const projectId = parseInt(this.$route.params.id, 10);
    this.getProjects().then(() => {
      this.currentProject = this.projects.find(project => (project.id === projectId));
    });
  },
};
</script>
<style lang="scss" scoped>
.admin-project-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f6f6f6;
  height: 100vh;
}
.admin-project {
  width: 900px;
  background-color: white;
  border: 1px solid #e8e8e8;
}
.navigation-bar {
  width: 100%;
  display: flex;
  justify-content: space-around;

  a {
    height: 60px;
    display: flex;
    width: 50%;
    justify-content: center;
    align-items: center;
  }

  .router-link-active {
    border-bottom: 2px solid blue;
  }
}
.current-project-background {
  padding-top: 260px;
  width: 100%;
  display: flex;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.current-project {
  color: white;
  width: 900px;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 25px 20px;
  font-family: 'Roboto Condensed', sans-serif;
  font-weight: bolder;
  font-size: 26px;
  text-transform: uppercase;

  span {
    font-family: 'Roboto', sans-serif;
    text-transform: none;
    font-size: 16px;
  }
}
.view {
  padding: 30px;
}
/deep/ .actions {
  width: 30%;
  display: flex;
}
/deep/ .action {
  width: 50%;
  border-left: 1px solid rgb(223, 222, 222);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  flex-direction: column;
  cursor: pointer;
}
/deep/ .svg-icon {
  width: 20px;
  margin-bottom: 8px;
}
/deep/ .header {
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
}
/deep/ .header-title {
  font-family: 'Roboto Condensed', sans-serif;
  font-weight: bolder;
  text-transform: uppercase;
  font-size: 28px;
}
@media only screen and (max-width: 1100px) {
}
</style>
